import { render, staticRenderFns } from "./CartOrderBox.vue?vue&type=template&id=50fbbb53"
import script from "./CartOrderBox.vue?vue&type=script&lang=js"
export * from "./CartOrderBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports